import { Card, Flex } from 'antd';
import { ReactNode } from 'react';
import './index.scss';

interface CardProps {
  AccountNumber?: string;
  Currency?: string;
  CardTitle?: string;
  CardBalance?: string;
  Icon?: ReactNode;
  CardBackground?: string;
  CardBorderColor?: string;
  showIsActive?: boolean;
  isActive?: boolean;
  onClick?: (_id: number | undefined) => void;
  id?: number;
  accountName?: string;
  userData?: any;
}

const MiniCustomCard: React.FC<CardProps> = ({
  AccountNumber,
  accountName,
}) => {
  const formattedAccountNumber = AccountNumber
    ? AccountNumber.match(/.{1,4}/g)?.join(' ')
    : '';

  return (
    <Card size="small" className="bank-card-mini">
      <div className="card-content">
        <div className="card-footer">
          <div className="footer-content">
            <div className="cardholder-details">
              <div className="cardholder-name">{accountName}</div>
              <div className="account-number">
                {formattedAccountNumber}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default MiniCustomCard;
